import { DateTime } from 'luxon';

const formats = {
  DATE_SHORT: DateTime.DATE_SHORT,
  TIME_24_SIMPLE: DateTime.TIME_24_SIMPLE,
  TIME_24_WITH_SECONDS: DateTime.TIME_24_WITH_SECONDS,
  DATETIME_SHORT: DateTime.DATETIME_SHORT,
  DATETIME_SHORT_WITH_SECONDS: DateTime.DATETIME_SHORT_WITH_SECONDS,
  CHART: DateTime.DATETIME_SHORT_WITH_SECONDS,
  CLOCK_FOOTER: DateTime.DATETIME_FULL_WITH_SECONDS,
  ISO_DATE: 'yyyy-MM-dd',
  ISO_TIME: 'HH:mm:ss',
  ISO_TIME_WITHOUT_SECONDS: 'HH:mm',
};

const locales = {
  EN_US: 'en-US',
  ES_ES: 'es-ES',
  PT_BR: 'pt-BR',
};

const timezones = {
  DEFAULT: 'America/Sao_Paulo',
  SYSTEM_DATE_ONLY: 'UTC-3',
  UTC: 'UTC',
};

export {
  formats,
  locales,
  timezones,
};
